// `/` route — the auth gate.
//
// Behaviour:
//   1. wait for the shared session to hydrate
//   2. if not authenticated → redirect to /login
//   3. otherwise → redirect to the first view the session grants
//
// There is no persona selector: a user signs straight into a view and
// switches between their granted views from the sidebar.
//
// The Vite build can't gate server-side, so this runs as a client component
// with a minimal loading state until the session resolves. It reads the
// shared SessionContext (backed by the `['auth','session']` query) rather
// than fetching the session itself, so the gate adds no extra request.

import { useEffect } from 'react';
import { useNavigate } from 'react-router';
import { useSession } from '@/contexts/SessionContext';

export function HomePage() {
    const navigate = useNavigate();
    const { user, grantedFrontends, isHydrating } = useSession();

    useEffect(() => {
        if (isHydrating) return;
        if (!user) {
            navigate('/login', { replace: true });
            return;
        }
        // Land on the first granted view in canonical order.
        const target = grantedFrontends[0];
        navigate(target ? `/${target}` : '/login', { replace: true });
    }, [navigate, user, grantedFrontends, isHydrating]);

    return (
        <div className="flex-1 flex items-center justify-center text-body text-[rgb(var(--color-text-secondary))]">
            Loading…
        </div>
    );
}
